module.exports = __webpack_public_path__ + "static/img/avatar1.8fa304a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/avatar1.jpg
// module id = 57
// module chunks = 6